import ReactMarkdown from 'react-markdown';

// Renders admin-authored markdown (T&C / Privacy). Safe by default: raw HTML in
// the source is escaped, not executed.
export function Markdown({ children }: { children: string }) {
  return (
    <div className="prose prose-sm max-w-none text-slate-700">
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
